/* Robust cart bubble fix: exclude $2 "back text" add-ons and paint any style of badge */
(function(){
  function countParentsFromDOM(){
    var n = 0;
    document.querySelectorAll('.cart-items tbody tr.cart-item:not(.is-addon) .quantity__input')
      .forEach(function(inp){ var v = parseInt(inp.value||'0',10); if(!isNaN(v) && v>0) n += v; });
    return n;
  }
  function isAddonTitle(t){
    return /(back\s*side\s*text|back\s*text|add\s*text\s*(to\s*(the\s*)?)?back|text\s*back|engrave\s*back|back\s*engraving|backside\s*text|reverse\s*text)/i.test(t || '');
  }
  function countParentsFromCart(cart){
    var n = 0;
    (cart.items || []).forEach(function(it){
      var title = String(it.title || '').toLowerCase();
      var unitCents = Number(it.final_price || it.price || 0);
      var looksAddon = isAddonTitle(title) || (/(text|engrave|back|reverse)/i.test(title) && unitCents > 0 && unitCents <= 200);
      if(!looksAddon) n += (it.quantity || 0);
    });
    return n;
  }
  function setHidden(el, hide){ if(!el) return; if(hide) el.setAttribute('hidden',''); else el.removeAttribute('hidden'); }
  function replaceDigitsInTextNodes(root, val){
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while((node = w.nextNode())){
      if(/\d+/.test(node.nodeValue)){ node.nodeValue = node.nodeValue.replace(/\d+/, String(val)); return true; }
    }
    return false;
  }
  function paintAllBubbles(n){
    document.querySelectorAll('.cart-count-bubble').forEach(function(b){
      var visible = b.querySelector('span[aria-hidden="true"]');
      if(visible) visible.textContent = n;
      var sr = b.querySelector('span:not([aria-hidden])');
      if(sr) sr.textContent = String(n);
      setHidden(b, n === 0);
    });
    document.querySelectorAll('#cart-icon-bubble,[data-cart-count]').forEach(function(el){
      try{ el.setAttribute('data-cart-count', n); }catch(e){}
    });
    document.querySelectorAll('a[href$="/cart"], a[href*="/cart?"]').forEach(function(a){
      var counter = a.querySelector('[class*="count"],[class*="bubble"],[class*="badge"],[id*="count"],[id*="bubble"],[data-count]');
      if(counter){ counter.textContent = n; setHidden(counter, n === 0); }
      else{ replaceDigitsInTextNodes(a, n); }
      try{ a.setAttribute('data-cart-count', n); }catch(e){}
    });
  }
  function refreshBubble(){
    var haveCartTable = !!document.querySelector('.cart-items');
    var domCount = haveCartTable ? countParentsFromDOM() : 0;
    if(haveCartTable){ paintAllBubbles(domCount); }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){ paintAllBubbles(countParentsFromCart(cart)); })
      .catch(function(){});
  }
  document.addEventListener('DOMContentLoaded', refreshBubble);
  setTimeout(refreshBubble, 120);
  setTimeout(refreshBubble, 600);
  document.addEventListener('shopify:section:load', refreshBubble);
  document.addEventListener('cart:refresh', refreshBubble);
  document.addEventListener('ajaxCart:afterAdd', refreshBubble);
  document.addEventListener('change', function(e){
    if(e.target && e.target.classList && e.target.classList.contains('quantity__input')) refreshBubble();
  }, true);
  document.addEventListener('click', function(e){
    if(e.target && (e.target.closest('.quantity__button') || e.target.closest('cart-remove-button'))) {
      setTimeout(refreshBubble, 0);
    }
  }, true);
})();